import { Redirect } from "react-router-dom";
import { RouteProvider } from "./Provider";
import React, { useDispatch, useGlobal, useState } from "reactn";

const SignUpScreen = ({ match, location, history, children }) => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const [step, setStep] = useState(0);
	const [email, setEmail] = useState(null);
	const [user] = useGlobal("user");
	const doSignUpWithPass = useDispatch("doSignUpWithPass");

	const signUp = (user) => {
		setLoading(true);
		doSignUpWithPass(user)
			.then(() => {
				setLoading(false);
				setStep(2);
			})
			.catch((err) => {
				setError(err);
				setLoading(false);
			});
	};

	const next = (props) => {
		if (step === 0) {
			setEmail(props.email);
			setError("");
			setStep(1);
			return;
		}
		if (step === 1) {
			const { password, name } = props;
			signUp({ email, password, name });
		}
	};

	const prev = () => setStep(0);

	if (user && user.token && step !== 1) return <Redirect to="/" />;

	return children({
		prev,
		next,
		loading,
		step,
		email,
		error: mapErrorToMessage(error),
	});
};

const mapErrorToMessage = (error) => {
	switch (error) {
		case "weak-password":
			return "Tu contraseña no cumple con los requisitos de una contraseña segura";
		case "empty-email":
			return "Por favor, rellena tu correo electrónico.";
		case null:
		case "":
			return null;
		default:
			return "Ha ocurrido un error. Revisa que no te hayas registrado anteriormente.";
	}
};

export default RouteProvider(SignUpScreen);
